import { NgModule } from '@angular/core';
import { GtmGgProductPageEventBuilder } from './gtm-gg-product-page-event.builder';

@NgModule({})
export class GtmGgProductPageEventModule {
  constructor(_gtmGgProductPageEventBuilder: GtmGgProductPageEventBuilder) {}
}
